import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { getBranding } from "../../hooks/tennant";
import axiosInstance from "../../api/axiosInstance";
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import "./login.scss"

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [code, setCode] = useState("");
    const [error, setError] = useState("");
    const [userId, setUserId] = useState(null);
    const [step, setStep] = useState(1);
    const [qr, setQr] = useState("");
    const [branding, setBranding] = useState(null);
    const [isLoading, setLoading] = useState(false);

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        const loadBranding = async () => {
            try {
                const data = await getBranding();
                setBranding(data);
            } catch (error) {
                console.error("Branding konnte nicht geladen werden:", error);
            }
        };

        loadBranding();
    }, []);

    const resetMfa = () => {
        setStep(1);
        setUsername("");
        setPassword("");
        setCode("");
        setUserId(null);
        setQr("");
        setError("");
    };

    const fetchQr = async (userId) => {
        const res = await axiosInstance.get(`/auth/mfaSetup/${userId}`);
        setQr(res.data.qr);
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        setLoading(true);
        setError("");

        try {

            const response = await axiosInstance.post(`auth/login`, {
                username,
                password,
                code: step !== 1 ? code : undefined,
            });

            if (response.data.requireMfaSetup) {
                setUserId(response.data.userId);
                await fetchQr(userId);
                setStep(2);
                return;
            }

            if (response.data.requireMfa) {
                setStep(3);
                return;
            }

            const { token } = response.data;

            await login(token);

            navigate("/");

        } catch (err) {
            setError(
                err.response?.data?.error ||
                "Fehler bei der Anmeldung."
            );

        } finally {
            setLoading(false);
        }
    };

    return !branding ? (<div />) : (
        <div className="login">
            <div className="left">
                <div className="container">
                    <img src={`/assets/branding/${branding.logo}`} alt="Logo" />
                    <form onSubmit={handleLogin}>
                        {step === 1 && (
                            <>
                                <h2>Anmelden</h2>
                                <div className="block">
                                    <input
                                        type="text"
                                        placeholder="Benutzername"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                        autoFocus
                                        autoComplete="username"
                                    />
                                </div>

                                <div className="block">
                                    <input
                                        type="password"
                                        placeholder="Passwort"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        autoComplete="current-password"
                                    />
                                </div>
                            </>
                        )}

                        {step === 2 && (
                            <>
                                <div className="top">
                                    <button className="toggle" onClick={resetMfa}>
                                        <ArrowBackRoundedIcon />
                                        Zurück
                                    </button>
                                    <h2>Multi-Faktor-Authentifizierung einrichten</h2>
                                </div>
                                <p>Einrichtung erforderlich. Scannen Sie mit Ihrer Authentifizierungs-App den QR Code ein und bestätigen Sie den angezeigten TOTP Code.</p>
                                <span>QR Code mit Ihrer Authentifizierungs-App einscannen.</span>
                                <img src={qr} alt="MFA QR Code" />
                                <div className="block">
                                    <input
                                        type="text"
                                        placeholder="6-stelliger Code"
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                        required
                                        autoFocus
                                        autoComplete="off"
                                        maxLength={6}
                                    />
                                </div>
                            </>
                        )}

                        {step === 3 && (
                            <>
                                <div className="top">
                                    <button className="toggle" onClick={resetMfa}>
                                        <ArrowBackRoundedIcon />
                                        Zurück
                                    </button>
                                    <h2>Account Verifizierung</h2>
                                </div>
                                <p>Verifizierungscode erforderlich. Überprüfen Sie Ihre Authentifizierungs-App und Geben Sie den Code ein, um sich anzumelden.</p>
                                <span>6-stelliger Code, der von Ihrer App generiert wird.</span>

                                <div className="block">
                                    <input
                                        type="text"
                                        placeholder="Eingeben"
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                        required
                                        maxLength={6}
                                        autoFocus
                                        autoComplete="one-time-code"
                                    />
                                </div>
                            </>
                        )}

                        {error && <p className="errorMsg">{error}</p>}
                        <button type="submit" disabled={isLoading}>
                            {isLoading
                                ? "Lädt..."
                                : step === 1
                                    ? "Anmelden"
                                    : step === 2
                                        ? "Weiter"
                                        : "Überprüfen"
                            }
                        </button>
                    </form>
                </div>
            </div>
            <div className="right">
                <div className="content">
                    <img src={`/assets/branding/${branding.background}`} alt="Header" />
                </div>
            </div>
        </div>
    );
};

export default Login;